import { asyncModal } from "@/components/ui/modal/utils";
import ImageModal from "@/components/common/ImageModal";

export default function showImage(url) {
  return asyncModal({
    name: "image-modal",
    component: ImageModal,
    props: {
      url
    }
  });
}
